// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__ZEM5m","content":"RecentSearches_content__11SwS"};